import React from 'react';
import {
  formatSpecValue,
  getSpecIcon,
  getSpecLabel,
  sortSpecEntries,
} from 'api/utils/listingDetailMapper';

export interface ListingSpecsSectionProps {
  specs: Record<string, string>;
  title?: string;
}

const ListingSpecsSection: React.FC<ListingSpecsSectionProps> = ({
  specs,
  title = 'Bilgisayar Özellikleri',
}) => {
  const entries = sortSpecEntries(specs);
  if (entries.length === 0) return null;

  return (
    <div className="card mb-4">
      <div className="card-body">
        <h5 className="card-title mb-4">
          <i className="fas fa-laptop-code me-2 text-primary" />
          {title}
        </h5>
        <div className="listing-specs-grid">
          {entries.map(([key, value]) => (
            <div key={key} className="listing-specs-grid__row">
              <div className="listing-specs-grid__label">
                <i className={`fas fa-${getSpecIcon(key)} text-primary me-2`} aria-hidden="true" />
                {getSpecLabel(key)}
              </div>
              <div className="listing-specs-grid__value">{formatSpecValue(key, value)}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ListingSpecsSection;
